import { Component } from '@angular/core';
import { V2TextDisplay } from '../helpers/v2-text-display.extendable';

@Component({
  selector: 'v2-body-large-text',
  template: `
    <v2-text [color]="color" [lineClamp]="lineClamp">
      <ng-content></ng-content>
    </v2-text>
  `,
  styles: [
    `
      :host {
        display: block;
        font-family: Lato, sans-serif;
        font-size: 16px;
        font-weight: 500;
        line-height: 1.4;
      }
    `
  ]
})
export class V2BodyLargeText extends V2TextDisplay {}
